/**
 * Central Time formatting for the Owner portal.
 *
 * All timestamps returned by the backend are ISO-8601 in UTC. The Owner
 * portal is operated from US Central Time; rendering in UTC forces staff
 * to do mental timezone math on every glance. These helpers handle the
 * conversion once.
 *
 * Returns a nicely-formatted string with an explicit "CT" suffix so
 * there's never ambiguity about which timezone a value is in.
 */

const TZ = "America/Chicago";

function parse(v) {
  if (!v) return null;
  const d = typeof v === "string" || typeof v === "number" ? new Date(v) : v;
  return isNaN(d.getTime()) ? null : d;
}

/** "Apr 23, 2026, 3:14 PM CT" */
export function formatCT(value, opts = {}) {
  const d = parse(value);
  if (!d) return opts.fallback ?? "—";
  const s = d.toLocaleString("en-US", {
    timeZone: TZ,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${s} CT`;
}

/** "Apr 23, 2026" */
export function formatCTDate(value, opts = {}) {
  const d = parse(value);
  if (!d) return opts.fallback ?? "—";
  return d.toLocaleDateString("en-US", {
    timeZone: TZ,
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** "3:14 PM CT" */
export function formatCTTime(value, opts = {}) {
  const d = parse(value);
  if (!d) return opts.fallback ?? "—";
  const s = d.toLocaleTimeString("en-US", {
    timeZone: TZ,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${s} CT`;
}
